import fragments from './fragments';

// ==== COMPLETE STYLES ===
const riskAssessmentZonesP75Big = {
    key: "riskAssessmentZonesP75Big",
    data: {
        nameDisplay: "Slope deformations (LOS)",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.zoneBase, fragments.p75AttributeIntervalsZones]
            }]
        }
    }
};

const riskAssessmentZonesP75Small = {
    key: "riskAssessmentZonesP75Small",
    data: {
        nameDisplay: "Slope deformations (LOS)",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.zoneBaseSmall, fragments.p75AttributeIntervalsZones]
            }]
        }
    }
};

const riskAssessmentZonesP75DtsBig = {
    key: "riskAssessmentZonesP75DtsBig",
    data: {
        nameDisplay: "Slope deformations (DTS, filtered)",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.zoneBase, fragments.p75AttributeIntervalsZonesDts]
            }]
        }
    }
};

const riskAssessmentZonesP75DtsSmall = {
    key: "riskAssessmentZonesP75DtsSmall",
    data: {
        nameDisplay: "Slope deformations (DTS, filtered)",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.zoneBaseSmall, fragments.p75AttributeIntervalsZonesDts]
            }]
        }
    }
};

const riskAssessmentZonesLandslidesBig = {
    key: "riskAssessmentZonesLandslidesBig",
    data: {
        nameDisplay: "Landslides",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.zoneBase, fragments.landslides]
            }]
        }
    }
};

const riskAssessmentZonesLandslidesSmall = {
    key: "riskAssessmentZonesLandslidesSmall",
    data: {
        nameDisplay: "Landslides",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.zoneBaseSmall, fragments.landslides]
            }]
        }
    }
};

const riskAssessmentZonesSusceptibilityBig = {
    key: "riskAssessmentZonesSusceptibilityBig",
    data: {
        nameDisplay: "Susceptibility",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.zoneBase, fragments.susceptibility]
            }]
        }
    }
};

const riskAssessmentZonesSusceptibilitySmall = {
    key: "riskAssessmentZonesSusceptibilitySmall",
    data: {
        nameDisplay: "Susceptibility",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.zoneBaseSmall, fragments.susceptibility]
            }]
        }
    }
};

const riskAssessmentRoadsP75Big = {
    key: "riskAssessmentRoadsP75Big",
    data: {
        nameDisplay: "Slope deformation (LOS)",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.roadBase, fragments.p75AttributeIntervalsRoads]
            }]
        }
    }
};

const riskAssessmentRoadsP75Small = {
    key: "riskAssessmentRoadsP75BigSmall",
    data: {
        nameDisplay: "Slope deformation (LOS)",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.roadBaseSmall, fragments.p75AttributeIntervalsRoads]
            }]
        }
    }
};

const interferometryPointsDisplacementBig = {
    key: "interferometryPointsDisplacementBig",
    data: {
        nameDisplay: "Points displ",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.interferometryBase, fragments.relCm, fragments.velAvg]
            }]
        }
    }
};

const interferometryPointsDisplacementBigAsPoints = {
    key: "interferometryPointsDisplacementBigAsPoints",
    data: {
        nameDisplay: "Points displ",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.interferometryBaseAsPoints, fragments.relCmAsPoints, fragments.velAvg]
            }]
        }
    }
};

const interferometryPointsDisplacementSmall = {
    key: "interferometryPointsDisplacementSmall",
    data: {
        nameDisplay: "Points displ",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.interferometryBaseAsPoints, fragments.relCmSmall, fragments.velAvg]
            }]
        }
    }
};

const interferometryZonesBig = {
    key: "interferometryZonesBig",
    data: {
        nameDisplay: "Interf zones",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.zoneTransparent]
            }]
        }
    }
};

const interferometryZonesSmall = {
    key: "interferometryZonesSmall",
    data: {
        nameDisplay: "Interf zones",
        description: "",
        definition: {
            rules: [{
                styles: [fragments.zoneTransparentSmall]
            }]
        }
    }
};

export default {
    ...fragments,

    byKey: {
        riskAssessmentZonesP75Big,
        riskAssessmentZonesP75Small,

        riskAssessmentZonesP75DtsBig,
        riskAssessmentZonesP75DtsSmall,

        riskAssessmentZonesLandslidesBig,
        riskAssessmentZonesLandslidesSmall,

        riskAssessmentZonesSusceptibilityBig,
        riskAssessmentZonesSusceptibilitySmall,

        riskAssessmentRoadsP75Big,
        riskAssessmentRoadsP75Small,

        interferometryZonesBig,
        interferometryZonesSmall,

        interferometryPointsDisplacementBig,
        interferometryPointsDisplacementBigAsPoints,
        interferometryPointsDisplacementSmall
    }
}